module.exports = __webpack_public_path__ + "static/media/polygon-matic-logo52x52.961d78af.svg";